import type { LucideIcon } from "lucide-react";
import { getDealDetailsUrl, getLeadDetailsUrl } from "@/routes/paths";
import { TSearchDealItem, TSearchLeadItem, TSearchRecordingItem } from "@/services/search.service";
import { getCloudRecordingDetailsUrl } from "@/utils/paths";

export type SearchPage = {
  path: string;
  title: string;
  icon?: LucideIcon;
};

export type SearchItem =
  | { kind: "page"; page: SearchPage }
  | { kind: "lead"; lead: TSearchLeadItem }
  | { kind: "deal"; deal: TSearchDealItem }
  | { kind: "recording"; recording: TSearchRecordingItem };

/** Max results per group requested from GET /search. */
export const GROUP_LIMIT = 6;

/** In-app URL of a result (lead id / deal id / recording sessionId as `ref`). */
export const hrefFor = (item: SearchItem): string => {
  if (item.kind === "page") return item.page.path;
  if (item.kind === "lead") return getLeadDetailsUrl(item.lead.ref);
  if (item.kind === "deal") return getDealDetailsUrl(item.deal.ref);
  return getCloudRecordingDetailsUrl(item.recording.ref);
};
